import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'
import { Link } from 'react-router-dom'

const InfoExpandersItem = props => {
  return (
    <li
      className={classNames({
        'info-item': true,
        [props.className]: props.className
      })}
    >
      <Link to={props.href} onClick={props.onClick}>
        {props.iconName && <Icon name={props.iconName} className='left-icon' />}
        <span className='text'>{props.children}</span>
        {props.error && <Icon name='warning' className='error-icon' />}
        <Icon name='right' />
      </Link>
    </li>
  )
}

InfoExpandersItem.propTypes = {
  iconName: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  error: PropTypes.bool,
  className: PropTypes.string
}

export default InfoExpandersItem



// WEBPACK FOOTER //
// ./src/ui/lists/info-expanders-item.js